import React, { type PropsWithChildren } from 'react';

import { FormattedMessage } from 'react-intl';

import Link from '@atlaskit/link/link';

import { i18n } from './messages';

export const ATLASSIAN_SUPPORT_URL = 'https://support.atlassian.com/contact/#/';

type AtlassianSupportLinkProps = PropsWithChildren<{
	showHostname?: boolean;
}>;

const getLinkText = (showHostname: AtlassianSupportLinkProps['showHostname']) =>
	showHostname ? (
		new URL(ATLASSIAN_SUPPORT_URL).hostname
	) : (
		<FormattedMessage {...i18n.atlassianSupportLink} />
	);

export const AtlassianSupportLink = ({
	showHostname,
	children,
}: AtlassianSupportLinkProps): React.JSX.Element => (
	<Link href={ATLASSIAN_SUPPORT_URL} target="_blank">
		{React.Children.count(children) ? children : getLinkText(showHostname)}
	</Link>
);
